module.exports = __webpack_public_path__ + "img/sinteep.72467592.png";